import { useState } from 'react'
import BsButton from 'react-bootstrap/Button'

import { formatEasternDate } from 'helpers/dates'
import { useLabPermission } from 'hooks/useLabPermission'
import { useGetLabDeviceQuery } from 'store/services/devices'
import { UserPermission } from '../user/permissions'
import { ExpirationCell } from './ExpirationCell'
import { FirstCheckOutModal } from './FirstCheckOutModal'

interface IProps {
  deviceId: number
}

// TES-3191: shelf life of a device whose type is tracked; nothing for the others.
export const DeviceShelfLife = ({ deviceId }: IProps) => {
  const { data: device } = useGetLabDeviceQuery(deviceId)
  const canOverride = useLabPermission(UserPermission.OVERRIDE_DEVICE_SHELF_LIFE)
  const [overriding, setOverriding] = useState(false)

  const shelfLife = device?.shelfLife

  if (!device || !shelfLife) return null

  const years = shelfLife.shelfLifeMonths / 12

  return (
    <div className="col-12 mb-4" data-testid="device-shelf-life">
      <h5 className="card-title float-none mb-3">Shelf Life</h5>
      <table className="table table-sm table-bordered">
        <tbody>
          <tr>
            <th className="w-50">First Check-Out Date</th>
            <td>
              {formatEasternDate(device.firstCheckedOutAt, 'Not checked out yet')}
              {canOverride && (
                <BsButton
                  size="sm"
                  variant="link"
                  className="py-0"
                  onClick={() => setOverriding(true)}>
                  Override
                </BsButton>
              )}
            </td>
          </tr>
          <tr>
            <th>Expiration Date</th>
            <td>
              <ExpirationCell device={device} />
              <small className="text-muted ml-2">
                {years} {years === 1 ? 'year' : 'years'} from the first check-out
              </small>
            </td>
          </tr>
          <tr>
            <th>Used Count</th>
            <td>{device.usedCount ?? 0}</td>
          </tr>
        </tbody>
      </table>

      <FirstCheckOutModal
        show={overriding}
        deviceId={Number(device.id)}
        firstCheckedOutAt={device.firstCheckedOutAt}
        onClose={() => setOverriding(false)}
      />
    </div>
  )
}
